import request from "@/utils/request";
import qs from "qs";

/**
 * 登录【ok】
 * @param params
 * @returns {*}
 */
export function login(params) {
  return request.post("/agentAuth/loginbypw", qs.stringify(params));
}

/**
 * 刷新权限
 */
export function refreshPermMenu() {
  return request({
    url: "/api/backend/refreshPermMenu",
    method: "get",
    params: {}
  });
}

export function getAgentUserInfo(params) {
  return request({
    url: "/agentAuth/getAgentUserInfo",
    method: "get",
    params: {}
  });
}
